module.exports = __webpack_public_path__ + "static/media/postgresql.45e46bc0.svg";